import React from "react";
import { Box } from "@mui/material";
import { CONTENT_MAX_WIDTH, skeletonSx } from "../shared/styles";

function SessionCardSkeleton() {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight: 152,
        p: "20px",
        borderRadius: "8px",
        boxSizing: "border-box",
        ...skeletonSx,
      }}
    />
  );
}

export default SessionCardSkeleton;
